// extracted by mini-css-extract-plugin
export default {"dot":"dot__19tZK","btnPulse":"btnPulse__2znwf"};